import { Query } from '@apollo/client/react/components';
import { CKButton, CKDrawer } from 'clearkit';
import get from 'lodash/get';
import startCase from 'lodash/startCase';
import moment from 'moment';
import ReactMarkdown from 'react-markdown';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import LoadingArea from '~/components/LoadingArea';

import query from './query.graphql';
import styles from './styles.style';

class NewsDetail extends React.Component {
  render() {
    const { data, id, loading, classes } = this.props;
    const newsArticles = get(data, 'news.articles', []);
    let newsItem;
    let previousArticle;

    for (let index = 0; index < newsArticles.length; index++) {
      const article = newsArticles[index];
      if (article.id == id) {
        newsItem = article;
        previousArticle = newsArticles[index + 1];
      }
    }

    const backgroundImage = get(newsItem, 'image');

    return (
      <LoadingArea className={classes.root} empty={!newsItem} loading={loading}>
        {newsItem && (
          <>
            {backgroundImage && (
              <CKDrawer.Header className="!p-0">
                <img
                  alt="news-detail"
                  className={classes.headerImage}
                  src={`https://${backgroundImage}`}
                />
              </CKDrawer.Header>
            )}
            <CKDrawer.Body className={classes.body}>
              <div className={classes.header}>
                <span className={classes.title}>{newsItem.title}</span>
                <p className={classes.timeago}>
                  {startCase(moment(get(newsItem, 'createdAt')).fromNow())}
                </p>
              </div>
              <ReactMarkdown>{newsItem.body}</ReactMarkdown>
            </CKDrawer.Body>
            {previousArticle && (
              <CKDrawer.Footer className="!justify-start">
                <div>
                  <div className={classes.dimTitle}>Previously</div>
                  <CKButton
                    as={Link}
                    to={`/news/${previousArticle.id}`}
                    variant="tertiary"
                    variantColor="blue"
                  >
                    {previousArticle.title}
                  </CKButton>
                </div>
              </CKDrawer.Footer>
            )}
          </>
        )}
      </LoadingArea>
    );
  }
}

NewsDetail.propTypes = {
  data: PropTypes.shape({
    news: PropTypes.shape({
      articles: PropTypes.PropTypes.arrayOf(
        PropTypes.shape({
          createdAt: PropTypes.string,
          title: PropTypes.string,
          body: PropTypes.string,
          image: PropTypes.string,
        }),
      ),
    }),
  }),
  history: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  classes: PropTypes.object,
};

const WrappedNewsDetail = (props) => (
  <Query query={query}>
    {(graphQLProps) => <NewsDetail {...graphQLProps} {...props} />}
  </Query>
);

export default withRouter(withStyles(styles)(WrappedNewsDetail));
